import styled from 'styled-components';
import {
  ProSidebar,
  MenuItem,
} from "react-pro-sidebar";
import { Menu } from 'antd';

export const StyledProSidebar = styled(ProSidebar)`
    min-width: 180px;
    width: 200px;
    z-index: 10; 
    overflow: hidden;
    overflow-y: auto;
    z-index: 100;
    color: #181a1c;
    position: fixed;
    border-right: 1px solid #EEEEEE;
    .pro-sidebar-inner {
      background-color: #fff !important;
    } 
    .pro-menu{
      padding-top: 15px !important;
    }
    ${({ theme }) =>
      theme.media.monitor(
      `
        min-width: 240px;
        width: 240px;
      `,
    )}
`;

export const StyledMenu = styled(Menu)`
  .ant-menu-item,
  .ant-menu-submenu {
    margin: 0px !important;
    height: 50px !important;
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    color: #181a1c !important;
    font-family: 'Suit medium';
    font-weight: 500;
    font-size: 14.5px;
    span {
      white-space: pre-wrap;
      line-height: 1.2vw;
    }
    ${({ theme }) =>
      theme.media.monitor(
        `
          svg {
            font-size: 20px !important;
          }
          font-weight: 500;
          font-size: 18px;
          height: 65px !important;
        `,
    )}
    ${({ theme }) =>
    theme.media.mobile(
      `
       width: 70px;
       font-size: 10px;
      `,
    )}
  }

  .ant-menu-item-active::after,
  .ant-menu-item-selected::after,
  .ant-menu-submenu-active::after,
  .ant-menu-submenu-selected::after {
    border-bottom-width: 0px !important;
    border-bottom-color: transparent !important;
  }

  .ant-menu-item-active {
    font-family: 'Suit medium';
    font-size: 14.5px;
    border-radius: 0px !important;
    background-color:  rgba(183, 183, 183, 0.09) !important;
    ${({ theme }) =>
      theme.media.monitor(
        `
          svg {
            font-size: 20px !important;
          }
          font-size: 20px;
        `,
    )}
    ${({ theme }) =>
    theme.media.mobile(
      `
       font-size: 10px;
      `,
    )}
  }

  .ant-menu-item-selected,
  .ant-menu-submenu-active,
  .ant-menu-submenu-selected {
    font-family: 'Suit medium';
    font-weight: 700;
    font-size: 14.5px;
    color: #5A1EDB !important;
    border-radius: 0px !important;
    background-color: rgba(90, 30, 219, 0.04) !important;
    ${({ theme }) =>
      theme.media.monitor(
        `
          font-weight: 700;
          font-size: 21px;
          svg {
            font-size: 21px !important;
          }
        `,
    )}
  }
`;